module.exports = __webpack_public_path__ + "img/IMG_9934-43_P_L_BlackMatted.fb1f2f33.jpg";